import React from 'react'
import PropTypes from 'prop-types'
import { mergeProps } from 'src/util'

/**
 * A [Grid](#/Layout?id=grid) item component to build complex layouts.
 */
const GridItem = ({
  column: gridColumn,
  row: gridRow,
  place: placeSelf,
  align: alignSelf,
  justify: justifySelf,
  as: Wrapper,
  ...domProps
}) => (
  <Wrapper
    {...mergeProps()(
      {
        style: {
          gridColumn,
          gridRow,
          alignSelf: alignSelf || (placeSelf && placeSelf.split(' ').shift()),
          justifySelf: justifySelf || (placeSelf && placeSelf.split(' ').pop()),
        },
      },
      domProps
    )}
  />
)

GridItem.defaultProps = {
  as: 'div',
}

GridItem.propTypes = {
  /**
   * CSS property `grid-column`.
   */
  column: PropTypes.string,
  /**
   * CSS property `grid-row`.
   */
  row: PropTypes.string,
  /**
   * CSS property `place-self`.
   */
  place: PropTypes.string,
  /**
   * CSS property `align-self`.
   */
  align: PropTypes.string,
  /**
   * CSS property `justify-self`.
   */
  justify: PropTypes.string,
  /**
   * The wrapper element of the grid item.
   */
  as: PropTypes.elementType,
}

export default GridItem
